module.exports = __webpack_public_path__ + "media/images/icons/clipboard-92ca287f15f6c9400f7d9e0074439fe6.svg";